
<template>
  <div>
    <v-container class="pt-0">
      <span v-if="showHeader" class="headline">{{$t('coinTransactions.title')}}</span>
      <v-row>
        <v-col>
          <coin-balance/>
        </v-col>
      </v-row>
      <v-container no-gutters class="pa-0">
        <v-row>
          <v-col>
            <v-btn to="/coins" class="">
              <v-icon left>mdi-circle-multiple-outline</v-icon>{{$t('coinTransactions.back-to-overview')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-data-table
              :loading="loading"
              :headers="tableHeaders"
              :items="transactions"
              hide-default-footer
              mobile-breakpoint="1"
              :items-per-page="1000"
            >
              <template v-slot:item.effectiveDate="{ item }">
                <span class="font-weight-thin">{{ dateStr(item.effectiveDate) }}</span>
              </template>
              <template v-slot:item.message="{ item }">
                {{ item.message }}
              </template>
              <template v-slot:item.amount="{ item }">
                {{ amountStr(item.amount) }}<v-icon right>mdi-circle-multiple-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import CoinBalance from "@/widgets/CoinBalance";
import coinMixin from "@/mixins/coinMixin";

export default {
  name: "CoinTransactions",
  mixins: [coinMixin],
  components: {
    CoinBalance    
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    loading: false,
    transactions: undefined,
    tableHeaders: [
      {
        text: "Datum",
        width: "2em",
        sortable: false,
        value: "effectiveDate",
      },
      {
        text: "Beschreibung",
        sortable: false,
        value: "message",
      },
      {
        text: "Buchung",
        sortable: false,
        align: "end",
        value: "amount",
      },
    ],
  }),
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh);
  },
  methods: {
    refresh: function () {
      this.loading = true;
      this.$api
        .getUserCoinTransactions()
        .then((res) => {
          this.loading = false;
          this.transactions = res.data.list;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    dateStr(isoDateStr) {
      return new Date(isoDateStr).toLocaleString();
    },
    amountStr(amount) {
      if (amount > 0) {
        return "+" + this.coinsToString(amount);
      }
      return this.coinsToString(amount);
    },
    openPurchaseProduct(product) {
      this.purchaseProduct(product.sku); // mixin
    },
  },
};
</script>
